import { Button, Card, Form, Spin } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { RcFile } from "antd/es/upload";
import EventDetailsForm from "./EventDetailsForm";
import ImageUploadForm from "./ImageUploadForm";
import EventRulesForm from "./EventRulesForm";
import TicketsForm from "./TicketsForm";
import dayjs from "dayjs";
import weekday from "dayjs/plugin/weekday";
import localeData from "dayjs/plugin/localeData";
import {
  useAddEventsMutation,
  useEditEventsMutation,
  useLazyGetEventByIdQuery,
  useLazyGetEventsCategoryQuery,
} from "../../../../services/events";
import { UploadMedia } from "../../../../utils/mediaUpload";
import { errorToast, successToast } from "../../../../helpers";
import { CommonBody, EventCategory, Events } from "../../../../types/General";
import { generateEncryptedKeyBody } from "../../../../utils/crypto";
import { ContentHeader } from "../../../../components";

const CatOptions = [{ name: "Launch Party" }, { name: "Success Party" }];

interface tickets {
  category: string;
  price: string;
  count: string;
  _id?: number | undefined;
}

const EventsForm = () => {
  dayjs.extend(weekday);
  dayjs.extend(localeData);
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { view, id } = useParams();

  console.log(id, "id");

  const [imageObject, setImageObject] = useState<RcFile[] | number[]>([]);
  const [imagePreview, setImagePreview] = useState<string[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>();
  const [ticketsValue, setTicketsValue] = useState<tickets[]>([]);
  const [loading, setLoading] = useState(false);
  const [ticketCat, setTicketCat] = useState("");
  const [ticketCount, setTicketCount] = useState("");
  const [ticketPrice, setTicketPrice] = useState("");
  const [eventValues, setEventValues] = useState({
    eventName: "",
    eventDescription: "",
    // hostName: "",
    location: "",
  });
  const [linksValues, setLinksValues] = useState({
    fbLink: "",
    instaLink: "",
    twitterLink: "",
  });
  const [getImages, setGetImages] = useState([]);
  const [vendorRule, setVendorRule] = useState(view === "add" ? " " : "");
  const [bookingRule, setBookingRule] = useState(view === "add" ? " " : "");
  const [cancelRule, setCancelRule] = useState(view === "add" ? " " : "");
  const [eventCategory, setEventCategory] = useState<EventCategory[]>([]);
  const [startDateTime, setStartDateTime] = useState<dayjs.Dayjs | null>(null);
  const [error, setError] = useState(false);
  const [eventDetail, setEventDetail] = useState<Events>();
  const [endDateTime, setEndDateTime] = useState<dayjs.Dayjs | null>(null);
  const [eventCategoryMethod] = useLazyGetEventsCategoryQuery();
  const [addEventsMethod] = useAddEventsMutation();
  const [editEventsMethod] = useEditEventsMutation();
  const [eventByIdMethod] = useLazyGetEventByIdQuery();

  const handleImageUpload = async (file: RcFile) => {
    setLoading(true);
    try {
      const res = await UploadMedia(file);
      setLoading(false);
      if (res?.statusCode === 200) {
        return res?.data;
      }
      return 0;
    } catch (error: any) {
      setLoading(false);
      console.log(error);
      return 0;
    }
  };

  const onFinish = async (values: any) => {
    setError(false);
    let newArr = ticketsValue as tickets[];
    if (ticketCat && ticketCount && ticketPrice) {
      newArr.push({
        price: ticketPrice,
        count: ticketCount,
        category: ticketCat,
      });
      setTicketCat("");
      setTicketCount("");
      setTicketPrice("");
    }
    if (!ticketsValue?.length && !ticketCat && !ticketCount) {
      setError(true);
      errorToast("Add Ticket Details first");
      return;
    }
    if (!selectedCategory || !startDateTime || !endDateTime) {
      setError(true);
      return;
    }
    if (!imageObject?.length && !getImages?.length) {
      // setImageError(true);
      errorToast("Please provide images/videos for event.");

      return;
    }

    let images = [] as any;
    let urls = [] as any;
    if (imageObject?.length) {
      await Promise.all(
        imageObject?.map(async (item) => {
          if (typeof item !== "number") {
            let result = await handleImageUpload(item);
            console.log(result);
            images?.push({
              image: result,
            });
          } else {
            images?.push({
              image: item,
            });
          }
        })
      );
      urls = images.map((item: any) => item.image);
    }
    let data = {
      // hostName: values.hostName,
      name: values.eventName,
      description: values.eventDescription,
      images: Array.from(getImages).concat(urls),
      time: startDateTime?.toISOString(),
      endTime: endDateTime?.toISOString(),
      eventCategoryId: selectedCategory,
      address: values.location,
      latitude: "76.804461",
      longitude: "30.727297",
      ticket: newArr,
      facebook: linksValues.fbLink,
      instagram: linksValues.instaLink,
      twitter: linksValues.twitterLink,
      vendorRules: vendorRule,
      bookingRules: bookingRule,
      cancellationRules: cancelRule,
    };

    console.log(data, "data");

    const body = generateEncryptedKeyBody(data) as CommonBody;
    setLoading(true);
    try {
      let res;
      {
        view === "add"
          ? (res = await addEventsMethod({ ownerId: id || "", body }).unwrap())
          : (res = await editEventsMethod({
              body,
              eventId: view || "",
            }).unwrap());
      }
      setLoading(false);
      if (res?.statusCode === 200) {
        successToast(
          view === "add"
            ? "Event Added Successfully"
            : "Event Updated Successfully"
        );
        navigate(`/manage-event-owner/details/${id}`, { replace: true });
      }
    } catch (error: any) {
      setLoading(false);
      errorToast(error?.data?.message || error?.data?.error);
    }
  };

  const handleImageDelete = (index: number) => {
    let previewImages = imagePreview.filter((_, i) => i !== index);
    setImagePreview(previewImages);
    let objectImages = (imageObject as any).filter(
      (_: any, i: number) => i !== index
    );
    setImageObject(objectImages as any);
  };

  const handleGetImageDelete = (index: number) => {
    let previewImages = getImages.filter((_, i) => i !== index);
    setGetImages(previewImages);
  };

  const getEventCategoryData = async () => {
    try {
      setLoading(true);
      const res = await eventCategoryMethod({}).unwrap();
      setLoading(false);
      if (res?.statusCode === 200) {
        setEventCategory(res?.data?.eventCategory || []);
      }
    } catch (error: any) {
      setLoading(false);
      errorToast(error?.data?.message || error?.data?.error);
    }
  };

  const getEventDetailData = async () => {
    try {
      setLoading(true);
      if (view) {
        const res = await eventByIdMethod({ eventId: view }).unwrap();
        setLoading(false);
        if (res?.statusCode === 200) {
          setEventDetail(res?.data);
          setVendorRule(res?.data?.vendorRules);
          setBookingRule(res?.data?.bookingRules);
          setCancelRule(res?.data?.cancellationRules);
          setSelectedCategory(res?.data?.eventCategory?._id);
          setStartDateTime(dayjs(dayjs(res?.data?.time)));
          setTicketsValue(res?.data?.ticket);
          setEndDateTime(dayjs(dayjs(res?.data?.endTime)));
          setEventValues({
            ...eventValues,
            eventName: res?.data?.name,
            eventDescription: res?.data?.description,
            // hostName: res?.data?.hostName,
            location: res?.data?.address,
          });
          setLinksValues({
            ...linksValues,
            fbLink: res?.data?.facebook,
            twitterLink: res?.data?.twitter,
            instaLink: res?.data?.instagram,
          });
          form.setFieldsValue({
            eventName: res?.data?.name,
            eventDescription: res?.data?.description,
            // hostName: res?.data?.hostName,
            location: res?.data?.address,
          });
          setGetImages(res?.data?.images);
        }
      }
    } catch (error: any) {
      setLoading(false);
      errorToast(error?.data?.message || error?.data?.error);
    }
  };

  useEffect(() => {
    getEventCategoryData();

    if (view !== "add") {
      getEventDetailData();
    }
  }, []);

  return (
    <div style={{ padding: 50 }}>
      <Spin spinning={loading}>
        <ContentHeader
          buttonText="Back"
          buttonNavigateTo={`manage-event-owner/details/${id}`}
          heading={view === "add" ? "Add Events" : "Edit Events"}
        />
        <Card>
          <div>
            <Form
              name="basic"
              layout="vertical"
              form={form}
              style={{
                maxWidth: "100%",
                marginTop: 10,
                gap: 20,
                display: "grid",
              }}
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <EventDetailsForm
                CatOptions={CatOptions}
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
                setEventValues={setEventValues}
                eventValues={eventValues}
                eventCategory={eventCategory}
                setStartDateTime={setStartDateTime}
                startDateTime={startDateTime}
                error={error}
                setEndDateTime={setEndDateTime}
                endDateTime={endDateTime}
              />

              <TicketsForm
                setTicketsValue={setTicketsValue}
                ticketsValue={ticketsValue}
                ticketCat={ticketCat}
                setTicketCat={setTicketCat}
                setTicketCount={setTicketCount}
                ticketCount={ticketCount}
                setTicketPrice={setTicketPrice}
                ticketPrice={ticketPrice}
              />

              <ImageUploadForm
                handleImageDelete={handleImageDelete}
                handleGetImageDelete={handleGetImageDelete}
                imagePreview={imagePreview}
                setImagePreview={setImagePreview}
                imageObject={imageObject}
                setImageObject={setImageObject}
                getImages={getImages}
              />

              <EventRulesForm
                setVendorRule={setVendorRule}
                vendorRule={vendorRule}
                bookingRule={bookingRule}
                setBookingRule={setBookingRule}
                cancelRule={cancelRule}
                setCancelRule={setCancelRule}
                error={error}
                eventDetail={eventDetail}
              />

              <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
                <div style={{ display: "flex" }}>
                  <Button
                    style={{
                      background: "#ECAC35",
                      width: 200,
                      height: 50,
                      margin: "auto",
                      color: "black",
                    }}
                    type="primary"
                    htmlType="submit"
                    onClick={() => {
                      setError(true);
                    }}
                  >
                    {view === "add" ? "Add" : "Edit"}
                  </Button>
                </div>
              </Form.Item>
            </Form>
          </div>
        </Card>
      </Spin>
    </div>
  );
};

export default EventsForm;
